export enum ShopOnboardingStatus {
  NO_SHOP = 'NO_SHOP',
  SHOP_CREATED = 'SHOP_CREATED',
  CONTRACT_CREATED = 'CONTRACT_CREATED',
  FTX_ACCOUNT_CREATED = 'FTX_ACCOUNT_CREATED',
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
}
